<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :title="$t('model.agent')"
    resource="agents"
    :onFetchData="onFetchData"
    :tabs="tabs"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/agents.js';
import _ from 'lodash';
import { TEST_ACCOUNT_FOR_APPLE } from '@/constants';
import TransactionHistory from './transaction_history/index.vue';
import WithdrawalApplications from './withdrawal_applications.vue';

@Component({
  components: {
    TransactionHistory,
    WithdrawalApplications
  }
})
export default class Agents extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  merchants = undefined

  get tabs() {
    const agentDetailtitle = `${this.$t('model.agent')}-${this.$t('bean.actionDetail')}`
    return [
      {
        label: agentDetailtitle,
        columns: this.columns(this.$createElement, { type: 'show' }),
      },
      {
        label: this.$t('menu.allTransactions'),
        can: 'plutus_entries.read',
        showAction: false,
        renderCell: (h, value) => {
          if (value) {
            return <TransactionHistory type="index" miapayWalletHolderId={value.miapay_wallet_holder_attributes.id} title={agentDetailtitle} />
          }
        }
      },
      {
        label: this.$t('model.withdrawalApplication'),
        can: 'withdrawal_applications.read',
        showAction: false,
        renderCell: (h, value) => {
          if (value) {
            return <WithdrawalApplications type="index" miapayWalletHolderId={value.miapay_wallet_holder_attributes.id} title={agentDetailtitle} />
          }
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        key: 'store_owner_id_eq',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/store_owners/read_options', { per_page: 100 })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/store_owners/read_options', { keyword })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            }
          }
        }
      },
      'merchant_id_eq',
      'miapay_wallet_holder_phone_cont',
      'status_eq',
      {
        prop: 'is_deleted',
        label: this.$t('user.isDeleted'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { label: this.$t('bean.yes'), value: true },
              { label: this.$t('bean.no'), value: false },
            ]
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      type === 'show' && {
        key: 'store_owner',
        minWidth: 150,
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'store_owners.show', params: { id: value.id } }}>{ value.name }</bean-link>;
          }
        }
      },
      type === 'show' && {
        key: 'merchant',
        minWidth: 150,
      },
      {
        key: 'phone',
        renderCell: (h, { props: { value } }) => {
          return <span>{ TEST_ACCOUNT_FOR_APPLE.includes(value) ? `${value} (Not real, test account for apple)` : value }</span>;
        }
      },
      type === 'show' && 'ref_code',
      'name',
      'status',
      type === 'show' && 'locked_at',
      type === 'show' && {
        key: 'balance',
        renderCell: (h, { props: { value } }) => {
          return <span>{ `${value || 0} (${this.$t('hint.remainingAfterDeductingPendingWithdrawal')})` }</span>;
        }
      },
      type === 'show' && 'cashback',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type, change }) {
    const array = [
      this.merchants && {
        prop: 'merchant_id',
        label: this.$t('model.merchant'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            clearable: true,
            options: this.merchants.map(({ id, name }) => ({ label: name, value: id }))
          },
          on: {
            change: (value) => {
              if (value) {
                const merchant = this.merchants.find((merchant) => (merchant.id === value));
                change({ store_owner_id: _.get(merchant, 'store_owner.id') })
              }
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      this.merchants && {
        prop: 'store_owner_id',
        label: this.$t('model.storeOwner'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            disabled: true,
            options: this.merchants.map(({ store_owner }) => {
              if (store_owner) {
                return { label: store_owner.name, value: store_owner.id };
              }
            }).filter(Boolean)
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        prop: 'miapay_wallet_holder_attributes.phone',
        label: this.$t('profile.phone'),
        renderCell: {
          component: 'input',
          required: true,
          hint: this.$t('hint.cannotChangeAfterCreate'),
          props: {
            disabled: type === 'edit',
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handleLock = async (id) => {
      await this.$autoLoading(this.$request.put(`/agents/${id}/locked_at_to_time_current`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleUnLock = async (id) => {
      await this.$autoLoading(this.$request.put(`/agents/${id}/locked_at_to_nil`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleApprove = async (id) => {
      await this.$autoLoading(this.$request.put(`/agents/${id}/approve`));
      this.$message.success(this.$t('approveAndSentSuccess'));
      reload();
    }

    const handleReject = async (id) => {
      await this.$autoLoading(this.$request.put(`/agents/${id}/reject`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'agents.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'agents.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      row.status !== 'approved' && row.status !== 'actived' && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.approve'),
          type: 'primary',
          can: 'agents.update'
        },
        on: {
          confirm: () => handleApprove(row.id)
        }
      },
      row.status === 'pending' && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.reject'),
          type: 'danger',
          can: 'agents.update'
        },
        on: {
          confirm: () => handleReject(row.id)
        }
      },
      !row.locked_at && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.isBlockToTrue'),
          type: 'danger',
          can: 'agents.update'
        },
        on: {
          confirm: () => handleLock(row.id)
        }
      },
      _.get(row, 'miapay_wallet_holder_attributes.locked_at') && {
        component: 'confirmButton',
        props: {
          label: this.$t('unlockWallet'),
          can: 'agents.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/agents/${row.id}/unlock_wallet`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_reset_password && {
        component: 'confirmButton',
        props: {
          label: this.$t('resetPassword'),
          can: 'agents.reset_password'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/agents/${row.id}/reset_password`));
            this.$message.success(this.$t('resetPasswordSuccess'));
            reload();
          }
        }
      },
      row.locked_at && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.isBlockToFalse'),
          type: 'primary',
          can: 'agents.update'
        },
        on: {
          confirm: () => handleUnLock(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/agents', { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'edit' || type === 'new') {
      const merchants = await this.$request.get('/merchants/read_options', { per_page: 999, agent_id_null: true });
      this.merchants = merchants.data;
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/agents/${this.$route.params.id}`);
      if (type === 'edit') {
        const { merchant_id, merchant, store_owner } = data;
        if (merchant_id) {
          this.merchants.unshift({ id: merchant_id, name: merchant.name, store_owner: store_owner });
        }
      }
      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }
}

export const route = [
  {
    path: '/agents',
    name: 'agents.index',
    component: Agents,
    props: {
      type: 'index',
    }
  },
  {
    path: '/agents/new',
    name: 'agents.new',
    component: Agents,
    props: {
      type: 'new',
    }
  },
  {
    path: '/agents/:id',
    name: 'agents.show',
    component: Agents,
    props: {
      type: 'show',
    }
  },
  {
    path: '/agents/:id/edit',
    name: 'agents.edit',
    component: Agents,
    props: {
      type: 'edit'
    }
  }
]
</script>
